import React from "react";
import { Box, Button, IconButton, CircularProgress } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { IMAGES } from "../../../assets/Images";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CampaignIcon from "@mui/icons-material/Campaign";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const IconButtonComponent = ({
  onclick,
  btnType,
  btnText,
  btntitle,
  disabled,
  loading = false,
  backgroundColor = "#B6BBC4"
}) => {
  const renderButton = () => {
    switch (btnType) {
      case "backbtn":
        return (
          <Button
            sx={{
              marginBottom: 2,
              fontWeight: 600,
              textTransform: "capitalize",
              backgroundColor: "none",
              color: "#2D3945",
              fontSize: 16,
              "&:hover": {
                color: "#4a6375",
                backgroundColor: "#fff !important",
                boxShadow: 2,
                borderRadius: "10px !important",
              },
              "&:active": { backgroundColor: "#fff !important" },
            }}
            onClick={onclick}
            startIcon={<ArrowBackIosIcon style={{ width: 16, height: 16 }} />}
          >
            {btnText}
          </Button>
        );

      case "addIconbtn":
        return (
          <IconButton
            onClick={onclick}
            sx={{
              backgroundColor: "#9834F0",
              color: "#fff",
              "&:hover": { color: "#fff", backgroundColor: "#a169ff !important" },
              "&:active": { backgroundColor: "#9834F0 !important" },
            }}
            aria-label="add-button"
          >
            <AddIcon />
          </IconButton>
        );

      case "viewIconbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              backgroundColor: "#9834F0",
              color: "#fff",
              "&:hover": { color: "#fff", backgroundColor: "#a169ff !important" },
              "&:active": { backgroundColor: "#9834F0 !important" },
            }}
            aria-label="add-button"
            disabled={disabled}
          >
            <VisibilityIcon />
          </IconButton>
        );

      case "deleteIconbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              backgroundColor: "#D06060",
              color: "#fff",
              "&:hover": { color: "#fff", backgroundColor: "#D96E6E !important" },
              "&:active": { backgroundColor: "#AD4E4E !important" },
              "&.Mui-disabled": { backgroundColor: "#E0E0E0 !important", color: "#D06060 !important" },
            }}
            aria-label="delete-button"
            disabled={disabled || loading}
          >
            {loading ? <CircularProgress size={20} style={{ color: '#D06060' }} /> : <DeleteIcon />}
          </IconButton>
        );

      case "closeIconbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            aria-label="close-button"
          >
            <img
              src={IMAGES.close}
              alt="close"
              style={{
                objectFit: "cover",
                width: "24px",
                height: "24px",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: "#D96E6E !important",
                },
              }}
            />
          </IconButton>
        );

      case "attachFilebtn":
        return (
          <IconButton
            type="file"
            title={btntitle}
            onClick={onclick}
            sx={{
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            aria-label="attach-file-button"
          >
            <AttachFileIcon />
          </IconButton>
        );

      case "sendbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              backgroundColor: "#28B882",
              color: "#fff",
              "&:hover": { color: "#fff", backgroundColor: "#5ECAA1 !important" },
              "&:active": { backgroundColor: "#239E70 !important" },
            }}
            aria-label="send-button"
          >
            <SendIcon />
          </IconButton>
        );

      case "infobtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            aria-label="info-button"
          >
            <InfoIcon />
          </IconButton>
        );

      case "editbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              backgroundColor: backgroundColor,
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            disabled={disabled || loading}
            aria-label="edit-button"
          >
            {loading ? <CircularProgress size={20} style={{ color: '#4A6375' }} /> : <EditIcon />}
          </IconButton>
        );

      case "uploadbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            aria-label="upload-button"
          >
            <UploadIcon />
          </IconButton>
        );

      case "contentbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            disabled={disabled}
            aria-label="upload-button"
          >
            <AssignmentIcon />
          </IconButton>
        );

      case "announcementBtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            sx={{
              color: "#4A6375",
              "&:hover": { color: "#4A6375" },
              "&:active": { color: "#4A6375" },
            }}
            aria-label="announcement-button"
          >
            <CampaignIcon />
          </IconButton>
        );

      case "admin-backbtn":
        return (
          <IconButton
            title={btntitle}
            onClick={onclick}
            aria-label="admin-back-btn"
          >
            <ArrowBackIosNewIcon fontSize="medium" />
          </IconButton>
        );

      default:
        return null;
    }
  };

  return <Box>{renderButton()}</Box>;
};

export default IconButtonComponent;
